import React from "react";
import nailColor from "./../../../Images/NailSalonInnerPages/Colour Change.png";

const NailColorImg = () => {
  return (
    <div className="nailExtImg">
      <img src={nailColor} alt="nailColor" />
    </div>
  );
};

export default NailColorImg;
